import { render, staticRenderFns } from "./PoliciesAndProceduresTable.vue?vue&type=template&id=e9daa242&"
import script from "./PoliciesAndProceduresTable.vue?vue&type=script&lang=js&"
export * from "./PoliciesAndProceduresTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports